<template>
  <v-layout row>
    <v-flex xs12 >
      <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Direcciones de envío</v-toolbar-title>
        </v-toolbar>
        <v-spacer></v-spacer>
      <v-list two-line>
          <template v-for="(item) in items">
            

            <v-list-tile
              :key="item.code"
            >
              <v-list-tile-content>
                <v-list-tile-title >
                    {{item.address}}
                    <span v-if="item.address2">, {{item.address2}}</span>
                    <span v-if="item.city">, {{item.city}}</span>
                    <span v-if="item.county">, {{item.county}}</span>
                    <span v-if="item.cp">, {{item.cp}}</span>
                </v-list-tile-title>
                <v-list-tile-sub-title >
                    {{item.name}} {{item.name2}}
                    <span v-if="item.phone">, {{item.phone}}</span>
                    <span v-if="item.email">, {{item.email}}</span>
                    <span v-if="item.horario">, {{item.horario}}</span>
                    <span v-if="item.zona">, {{item.zona}}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
    </v-flex>
  </v-layout>
</template>
<script>
  export default {
      name: 'addresses',
    data () {
      return {
        
      }
    },
    computed:{
        items: { //lineas
            get(){
                if (this.$store.state.customer != {})
                    return this.$store.state.customer.addresses;
                else
                    return [];
            }
        },
    }
  }
</script>